import React from 'react';
import CloseIcon from '../../../images/md-icons/close/materialicons/24px.svg';

import Pressable from '../Pressable';
import styles from './styles';
import PropTypes from 'prop-types';

const CloseButton = ({onPress, style}) => {
  return (
    <Pressable style={[styles.view, style]} onPress={onPress}>
      <CloseIcon />
    </Pressable>
  );
};
CloseButton.propTypes = {
  onPress: PropTypes.any,
  style: PropTypes.any,
};


export default CloseButton;
